import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Picture from './Picture.jsx'
import Details from './Details.jsx'
//import _ from 'lodash'

class EmployeeComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    return <div><Picture employee={this.props.employee}></Picture><br /><Details employee={this.props.employee}></Details></div>
  }
}

EmployeeComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  employee: PropTypes.object.isRequired,
}

export default EmployeeComponent
